import ProtectedRoute from '../../components/ProtectedRoute';
import ProfilePage from './components/ProfilePage';

import { PROFILE_PATH } from '../../constants/routes';

const Routes = [
  {
    path: PROFILE_PATH,
    Component: ProtectedRoute,
    children: [
      {
        index: true,
        Component: ProfilePage,
      },
    ],
  },
];

export default {
  Routes,
};
